import FormStateParams from "../interfaces/FormStateParams";

function SaveForm(
  id: string,
  json: JSON,
  webContentName: string | undefined,
  theme: any,
  routeParams: FormStateParams,
) {
  if (id === undefined) {
    return null;
  }
  const rp: FormStateParams = routeParams;
  if (rp == null || rp.webContentId === undefined) {
    return null;
  }

  let url = `${process.env.REACT_APP_API_URL}/api/newformeditor/${id}?`;

  const params = new URLSearchParams({
    accountKey: rp.accountKey,
    sessionId: rp.sessionId,
    userlcid: rp.userlcid,
    orgname: rp.orgname,
    userid: rp.userid,
  });

  url += params.toString();

  const requestOptions: RequestInit = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({
      json: JSON.stringify(json),
      webContentName,
      theme: theme !== null ? JSON.stringify(theme) : null,
    }),
  };
  return fetch(url, requestOptions).then((response) => {
    if (response.ok) {
      return response.json();
    }
    throw new Error(response.statusText);
  });
}

export default SaveForm;
